export default __webpack_public_path__ + "static/media/wordart.89878b56.png";